module.exports = __webpack_public_path__ + "img/search.8f178630.png";